import Icon from "../../Icon";
import { GRID_SELECTION_TAG_LIMIT } from "../../../modules/search/consts";

type TagsSelectionMessageProps = {
  hasNoLocalSamples: boolean;
  hasMixedSamples: boolean;
  selectedCountTotalOverLimit: boolean;
};

const TagsSelectionMessage = ({
  hasNoLocalSamples,
  hasMixedSamples,
  selectedCountTotalOverLimit
}: TagsSelectionMessageProps) => {
  return (
    <div className="d-flex align-items-start mb-20">
      <Icon name="info-circle" className="me-5" />
      <div>
        {selectedCountTotalOverLimit && (
          <div className="mb-10">
            This action is limited to {GRID_SELECTION_TAG_LIMIT} local samples.
          </div>
        )}
        {(hasNoLocalSamples || hasMixedSamples) && (
          <div>Tagging is supported for local samples only.</div>
        )}
      </div>
    </div>
  );
};

export default TagsSelectionMessage;
